import React, { useState } from 'react';

const VariablesPanel = ({ variables, onAdd, onUpdate, onDelete }) => {
    const [showAddForm, setShowAddForm] = useState(false);
    const [newVar, setNewVar] = useState({ key: '', label: '', type: 'text', required: false });

    const handleAdd = () => {
        if (!newVar.key.trim() || !newVar.label.trim()) return;

        // Sanitize key (lowercase, underscores)
        const key = newVar.key.toLowerCase().replace(/[^a-z0-9_]/g, '_');

        onAdd({
            key,
            label: newVar.label,
            type: newVar.type,
            required: newVar.required,
        });

        setNewVar({ key: '', label: '', type: 'text', required: false });
        setShowAddForm(false);
    };

    return (
        <div>
            <h4>Variables</h4>

            {variables.length === 0 ? (
                <p style={{ fontSize: '12px', color: 'rgba(248,248,248,0.4)', marginBottom: '12px' }}>
                    No variables yet. Add variables to create placeholders.
                </p>
            ) : (
                <div className="variables-list">
                    {variables.map((v) => (
                        <div key={v.key} className="variable-item">
                            <span className="variable-key">{`{{${v.key}}}`}</span>
                            <span className="variable-label">{v.label}</span>
                            <button
                                className="variable-insert-btn"
                                onClick={() => navigator.clipboard.writeText(`{{${v.key}}}`)}
                                title="Copy to clipboard"
                            >
                                Copy
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {showAddForm ? (
                <div style={{ marginTop: '12px', padding: '12px', background: 'rgba(255,255,255,0.04)', borderRadius: '8px' }}>
                    <div className="form-group" style={{ marginBottom: '10px' }}>
                        <label style={{ fontSize: '11px' }}>Key (e.g., buyer_name)</label>
                        <input
                            type="text"
                            value={newVar.key}
                            onChange={(e) => setNewVar({ ...newVar, key: e.target.value })}
                            placeholder="variable_key"
                            style={{ padding: '8px 10px', fontSize: '13px' }}
                        />
                    </div>
                    <div className="form-group" style={{ marginBottom: '10px' }}>
                        <label style={{ fontSize: '11px' }}>Label</label>
                        <input
                            type="text"
                            value={newVar.label}
                            onChange={(e) => setNewVar({ ...newVar, label: e.target.value })}
                            placeholder="Buyer Name"
                            style={{ padding: '8px 10px', fontSize: '13px' }}
                        />
                    </div>
                    <div className="form-group" style={{ marginBottom: '10px' }}>
                        <label style={{ fontSize: '11px' }}>Type</label>
                        <select
                            value={newVar.type}
                            onChange={(e) => setNewVar({ ...newVar, type: e.target.value })}
                            style={{ padding: '8px 10px', fontSize: '13px' }}
                        >
                            <option value="text">Text</option>
                            <option value="number">Number</option>
                            <option value="date">Date</option>
                            <option value="currency">Currency</option>
                        </select>
                    </div>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: 'rgba(248,248,248,0.7)', marginBottom: '12px' }}>
                        <input
                            type="checkbox"
                            checked={newVar.required}
                            onChange={(e) => setNewVar({ ...newVar, required: e.target.checked })}
                        />
                        Required
                    </label>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                            className="editor-btn secondary"
                            onClick={() => setShowAddForm(false)}
                            style={{ flex: 1, padding: '8px' }}
                        >
                            Cancel
                        </button>
                        <button
                            className="editor-btn primary"
                            onClick={handleAdd}
                            style={{ flex: 1, padding: '8px' }}
                            disabled={!newVar.key.trim() || !newVar.label.trim()}
                        >
                            Add
                        </button>
                    </div>
                </div>
            ) : (
                <button className="add-variable-btn" onClick={() => setShowAddForm(true)}>
                    + Add Variable
                </button>
            )}
        </div>
    );
};

export default VariablesPanel;
